import {
  ERROR_ASSESSMENT_CUTOFF_DAYS,
  SECONDS_IN_ONE_DAY,
} from "src/constants/constants";
import { AssessmentDetailsApiData } from "src/services/assessment/types/assessmentDetailsApiData";
import { EvaluationStatusEnum } from "src/services/assessment/types/evaluationStatusEnum";

export const getDate = (timestamp: number) => {
  const date = new Date(timestamp * 1000);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return [day, month, year].join("-");
};

export const getTimeDiffInSeconds = (timestamp: number) => {
  const past = new Date(timestamp * 1000);
  const now = new Date();
  return (now.getTime() - past.getTime()) / 1000;
};

export const getTimeStampDiffInSecond = (timestamp: number): number => {
  return (Date.now() - timestamp) / 1000;
};

export const isTimeStampValid = (timestamp: number): boolean => {
  if (timestamp === 0) return false;
  const timeDiffInSecond = getTimeStampDiffInSecond(timestamp);
  if (timeDiffInSecond < 2 || timeDiffInSecond > 1000) return false;
  return true;
};

export const ISOToLocalizedTimeFormat = (dateString: string): string => {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };
  const localizedTime = date.toLocaleString("en-US", options).replace(",", "");
  return localizedTime;
};
export const filterOldErroredAssessmentsByDays = (
  assessments: AssessmentDetailsApiData[]
) => {
  const nowInSeconds = Math.floor(Date.now() / 1000);
  const filteredAssessments = assessments.filter((assessment) => {
    const assessmentLastUpdatedAt = Number(
      assessment.initialEvaluation?.statusUpdateDate
    );
    const daysSinceLastUpdate =
      (nowInSeconds - assessmentLastUpdatedAt) / SECONDS_IN_ONE_DAY;
    const status = assessment.initialEvaluation?.status;
    if (
      status &&
      (status === EvaluationStatusEnum.ERROR ||
        status === EvaluationStatusEnum.UPLOADING) &&
      daysSinceLastUpdate > ERROR_ASSESSMENT_CUTOFF_DAYS
    ) {
      return false;
    }
    return true;
  });
  return filteredAssessments;
};
